<div class="images">
	{{#each frames}}
		<div class="spotlight-image" style="background-image: url({{getPreviewUrl image}});" data-frame="{{@index}}">
			<span class="spotlight-text">{{{getLocaleTextHTML text}}}</span>
		</div>
	{{/each}}
</div>
